import { motion } from 'motion/react';
import { useBrandLogos } from '@/pages/home/brandLogos';
import { brands } from '@/mocks/homeData';

export default function BrandsSection() {
  const { logos: serverLogos, loading } = useBrandLogos();

  // Use server logos if available, otherwise fall back to mock data
  const displayBrands = serverLogos.length > 0
    ? serverLogos
    : brands.map((b) => ({ src: b.logo, name: b.name }));

  return (
    <section id="brands" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="inline-block bg-secondary-100 text-secondary-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
            Authorized Dealer
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Brands We Carry
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Genuine products from the world&apos;s leading smartphone, TV, and appliance brands. Visit our store for the complete collection.
          </p>
        </motion.div>

        {loading && serverLogos.length === 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {Array.from({ length: 6 }).map((_, i) => (
              <div
                key={i}
                className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 flex items-center justify-center min-h-[100px] md:min-h-[120px] animate-pulse"
              >
                <div className="w-32 h-12 bg-background-200 rounded" />
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {displayBrands.map((brand, index) => (
              <motion.div
                key={brand.name}
                initial={{ opacity: 0, y: 20, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.4, delay: index * 0.06, ease: 'easeOut' }}
                whileHover={{ scale: 1.08, y: -4 }}
                className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 flex items-center justify-center min-h-[100px] md:min-h-[120px] transition-all duration-300 cursor-default"
              >
                <img
                  src={brand.src}
                  alt={`${brand.name} logo`}
                  className="w-full max-w-[180px] h-16 md:h-20 object-contain group-hover:scale-105 transition-transform duration-300"
                />
              </motion.div>
            ))}
          </div>
        )}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10 md:mt-12 text-center"
        >
          <p className="text-foreground-500 text-sm md:text-base">
            And many more accessories from top brands. Visit our store for the complete collection.
          </p>
        </motion.div>
      </div>
    </section>
  );
}